import type {
  NotificationField,
  NotificationRole,
  NotificationSettingsChanges,
} from '../../types/notification-settings';

export const ROLE_LABELS: Record<NotificationRole, string> = {
  owner: 'Request owner',
  submitter: 'Submitter',
  ideaOwner: 'Idea owner',
  PAOwner: 'Product area owner',
};

export function hasChange(
  changes: NotificationSettingsChanges,
  type: string,
  field: NotificationField,
): boolean {
  return Object.prototype.hasOwnProperty.call(changes[type] ?? {}, field);
}

export function pendingValue<T extends boolean | string>(
  changes: NotificationSettingsChanges,
  type: string,
  field: NotificationField,
  stored: T | null,
): T | null {
  return hasChange(changes, type, field) ? (changes[type][field] as T | null) : stored;
}

export function withChange(
  changes: NotificationSettingsChanges,
  type: string,
  field: NotificationField,
  value: boolean | string | null,
): NotificationSettingsChanges {
  return { ...changes, [type]: { ...changes[type], [field]: value } };
}

function formatValue(value: boolean | string | null | undefined): string {
  if (value === null || value === undefined) return 'unset';
  if (typeof value === 'boolean') return value ? 'on' : 'off';
  return `"${value.length > 40 ? `${value.slice(0, 40)}…` : value}"`;
}

export function describeChanges(changes: NotificationSettingsChanges): string[] {
  return Object.entries(changes).flatMap(([type, fields]) =>
    Object.entries(fields).map(([field, value]) => `${type}.${field} → ${formatValue(value)}`),
  );
}
